import { hasAnyRole } from '../../utils/roles';
import { ROLES } from '../../utils/roles';

const { ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_FINANCE, ROLE_SALES_CS } = ROLES;

const ALLOWED_ROLES_UPLOAD_CHARGEBACK_DOCUMENT = [ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_FINANCE, ROLE_SALES_CS];

export function canUploadChargebackDocument(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_UPLOAD_CHARGEBACK_DOCUMENT);
}
